module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/yogasix-040b6c3659ba8f38c40e8dd8730c3d3b.png";